// eslint-disable-next-line no-restricted-imports
import { InvestmentPurposeAndNatureFragment } from 'api/generated/graphql';
import {
  LegalClientInvestmentPurposeAndNatureEntity,
  InvestmentPurposeAndNatureDurationType,
  InvestmentObjectiveType,
  PlannedServiceType,
} from 'api/types/entity';
import { lodash } from 'helpers';

export const parseLegalClientInvestmentPurposeAndNatureEntity = (
  data: InvestmentPurposeAndNatureFragment
): LegalClientInvestmentPurposeAndNatureEntity => ({
  otherInvestmentObjective: data.otherInvestmentObjective ?? undefined,
  otherPlannedServices: data.otherPlannedServices ?? undefined,
  investmentDuration:
    InvestmentPurposeAndNatureDurationType[data.investmentDuration],
  investmentObjectives: lodash
    .compact(data.investmentObjectives)
    .map((v) => InvestmentObjectiveType[v]),
  plannedServices: lodash
    .compact(data.plannedServices)
    .map((v) => PlannedServiceType[v]),
});
